"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Primary_1 = __importDefault(require("@carvana/showroom-forms/Button/Primary"));
var showroom_tabs_1 = __importDefault(require("@carvana/showroom-tabs"));
var react_1 = __importDefault(require("react"));
var MoreInfoPanel_1 = __importDefault(require("./MoreInfoPanel"));
var PriceDetailsPanel_1 = __importDefault(require("./PriceDetailsPanel"));
var VehicleCard_1 = __importDefault(require("./VehicleCard"));
var ModalSections_1 = __importDefault(require("../../constants/ModalSections"));
var useShowNav_1 = __importDefault(require("../../hooks/useShowNav"));
var TileDataContext_1 = require("../TileDataContext");
require("@carvana/showroom-css-theme/Theme.css");
require("@carvana/showroom-tabs/index.css");
require("@carvana/showroom-forms/Button/index.css");
function MoreDetailsModalContent(_a) {
    var openTo = _a.openTo;
    var vehicleId = (0, TileDataContext_1.useTileDataContext)().tileData.vehicleId;
    var startingTab = openTo === ModalSections_1.default.PriceDetails
        ? 'price-details-tab'
        : 'more-info-tab';
    var showNav = (0, useShowNav_1.default)();
    var TabBar = showroom_tabs_1.default.TabBar, Tab = showroom_tabs_1.default.Tab, Panel = showroom_tabs_1.default.Panel;
    var tabs = [
        {
            group: 'price-details-tab',
            label: 'Price Details',
            content: function () { return react_1.default.createElement(PriceDetailsPanel_1.default, null); }
        },
        {
            group: 'more-info-tab',
            label: 'More Info',
            content: function () { return react_1.default.createElement(MoreInfoPanel_1.default, { openTo: openTo }); }
        }
    ];
    return (react_1.default.createElement("div", { "data-package": "merch-tile" },
        react_1.default.createElement("div", { className: "relative bg-white px-24 pb-72 pt-16 m:min-h-[calc(95vh-60px)] m:w-full" },
            react_1.default.createElement("div", { className: "mx-auto max-w-[424px]" },
                react_1.default.createElement(VehicleCard_1.default, null),
                showNav ? (react_1.default.createElement(showroom_tabs_1.default, { startingTab: startingTab },
                    react_1.default.createElement(TabBar, null, tabs.map(function (tab) { return (react_1.default.createElement(Tab, { className: "w-full", tabGroup: tab.group, key: tab.group },
                        react_1.default.createElement("p", null, tab.label))); })),
                    tabs.map(function (tab) { return (react_1.default.createElement(Panel, { className: "!bg-white !px-0 !py-24 !shadow-none", tabGroup: tab.group, key: tab.group }, tab.content())); }))) : (react_1.default.createElement(PriceDetailsPanel_1.default, null)))),
        react_1.default.createElement("div", { className: "absolute bottom-0 w-full border-t border-grey-2 bg-white px-24 py-16 m:px-[140px]" },
            react_1.default.createElement("a", { href: "/vehicle/".concat(vehicleId), "data-analytics-id": "vdp-cta-in-modal", onClick: function () { return console.log('click vdp cta in modal'); } },
                react_1.default.createElement(Primary_1.default, { className: "mx-auto !h-[40px] !min-h-[40px] w-full" }, "View Vehicle Details")))));
}
function MoreDetailsModalContentContainer(props) {
    return (react_1.default.createElement(TileDataContext_1.TileDataContextProvider, { tileData: props.tileData, availabilityInfo: props.availabilityInfo, financeInfo: props.financeInfo, assets: props.assets, userInfo: props.userInfo, utils: props.utils },
        react_1.default.createElement(MoreDetailsModalContent, { openTo: props.openTo })));
}
exports.default = MoreDetailsModalContentContainer;
//# sourceMappingURL=MoreDetailsModalContent.js.map